import { createSlice } from "@reduxjs/toolkit";

const domain = window.location.hostname;
let baseURL = "";
let title = "";

if (domain === process.env.REACT_APP_WEB_PARTS_URL) {
  baseURL = process.env.REACT_APP_PARTS_URL;
  title = "Parts POS - BuyPhone24";
} else if (domain === process.env.REACT_APP_WEB_ACCESSORIES_URL) {
  baseURL = process.env.REACT_APP_ACCESSORIES_URL;
  title = "Accessories POS - BuyPhone24";
} else if (domain === process.env.REACT_APP_WEB_MOBILE_URL) {
  baseURL = process.env.REACT_APP_API_URL;
  title = "Mobile POS - BuyPhone24";
} else if (domain === process.env.REACT_APP_LOCAL_URL) {
  baseURL = process.env.REACT_APP_API_URL;
  title = "POS System - BuyPhone24";
  // baseURL = process.env.REACT_APP_ACCESSORIES_URL;
  // baseURL = process.env.REACT_APP_PARTS_URL;
}

const initialState = {
  baseURL,
  domain,
  title,
  isPartsURL: baseURL === process.env.REACT_APP_PARTS_URL,
  isAccessoriesURL: baseURL === process.env.REACT_APP_ACCESSORIES_URL,
  isMobileURL: baseURL === process.env.REACT_APP_API_URL,
};

const domainSlice = createSlice({
  name: "domain",
  initialState,
  reducers: {},
});

export default domainSlice.reducer;
